import React from "react";
import RackLocationsCapture from "../RackLocations/RackLocationsCapture";
import RackLocationsScrubber from "../RackLocations/RackLocationsScrubber";

export default function RackLocationsField({ type, asset, disabledForm }) {
  return type === "scrubber" ? (
    <RackLocationsScrubber type={type} entity={asset} disabled={disabledForm} />
  ) : (
    <RackLocationsCapture type={type} entity={asset} disabled={disabledForm} />
  );
}

